// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router/routers';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { setSessionStore, isShowHouse_key } from './utils/localCache';
import mainStore from './store/storeMain';

Vue.config.productionTip = false;
Vue.use(ElementUI);
setSessionStore(isShowHouse_key, false);
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path.indexOf('familyStatusDetail') > 0) {
    mainStore.commit('updateIsShowHouse', true);
  } else {
    mainStore.commit('updateIsShowHouse', false);
  }
  next();
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js